export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/etsy.0c09d53.svg";